export const MILESTONEDATA = {
    // Non-print domestic no premedia
    nonprint_domestic_nopremedia:{
        submit: 0,
        premedia: null,
        first_comp: 10,
        print: null,
        delivery: 20
    },
    // Non-print domestic premedia
    nonprint_domestic_premedia: {
        submit: 0,
        premedia: 15,
        first_comp: 20,
        print: null,
        delivery: 30
    },
    // Non-print international no premedia
    nonprint_international_nopremedia: {
        submit: 0,
        premedia: null,
        first_comp: 8,
        print: null,
        delivery: 16
    },
    // Non-print international premedia
    nonprint_international_premedia: {
        submit: 0,
        premedia: 10,
        first_comp: 15,
        print: null,
        delivery: 25 
    },
    // print no premedia
    print_nopremedia: {
        submit: 0,
        premedia: null,
        first_comp: 10,
        print: 20,
        delivery: 35
    },
    // print premedia
    print_premedia: {
        submit: 0,
        premedia: 15,
        first_comp: 20,
        print: 30,
        delivery: 45
    }
    // 
}